<script setup lang="ts">
import {onMounted, reactive, ref, watch} from 'vue';
import {useI18n} from "vue-i18n";
import CustomButton from "@/components/Button/Button.vue";
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import SwitchToggle from "@/components/SwitchToggle/SwitchToggle.vue";
import CustomIncrement from "@/components/CustomIncrement/CustomIncrement.vue";
import {useHomepageStore} from "@/stores/homepageStore";
import * as WindowsUtils from "@/helpers/windowUtils";
import * as AssetsUtils from '@/helpers/assetsUtils';
import * as DestinationAutocomplete from '../composables/destinationsAutoComplete';
import * as Passengers from '../composables/passengers';
import * as Calendars from '@/composables/calendar';
import { useRoute } from "vue-router";
import { computed } from "vue";

import BookingModalTitle from "@/components/BookingComponent/mobile/BookingModalTitle.vue";
import {useSearchStore} from "@/stores/searchStore";
import DestinationInput from "@/components/GlobalHeader/DestinationInput.vue";
import DestinationPill from "@/components/Destination/DestinationPill.vue";
import {trackEvent} from "@/services/event.service";
import CustomSpinner from "@/components/CustomSpinner/CustomSpinner.vue";


const route = useRoute();
const isRecommendationsPage = computed(() => route.path === "/recommendations");

const emits =defineEmits<{
  'close': [boolean],
  'on-search': [void],
  'on-recommend': [void],
  'on-refresh': [void],
}>();

const props = defineProps({
  'refresh':{
    type: Boolean,
    default: false
  },
    tabindex: Number,
    canSelectSkipper: {
      type: Boolean,
      default: false,
    },
    isGulet: {
      type: Boolean,
      default: false,
    },
})

const {t} = useI18n();
const homepageStore = useHomepageStore();
const useDestinationAutocomplete = reactive(DestinationAutocomplete.useDestinationAutocomplete());
const usePassengers = reactive(Passengers.usePassengers())
const useCalendar = reactive(Calendars.useCalendar())
const searchStore = useSearchStore();
const selectedCategoryName = ref('')

function onDestination(location) {
  console.log("On Destination", location);
  useDestinationAutocomplete.query = location.name;
  homepageStore.selections.location = location
  homepageStore.current = 'none'
}

const onDate = () => {
  if (!useCalendar.toDate || isNaN(new Date(useCalendar.toDate).getTime())) {

    // Ensure fromDate is valid
    if (!useCalendar.fromDate || isNaN(new Date(useCalendar.fromDate).getTime())) {
      return;
    }

    const newToDate = new Date(useCalendar.fromDate);
    newToDate.setDate(newToDate.getDate() + 7);

    useCalendar.toDate = newToDate;
  }

  homepageStore.selections.dates = [useCalendar.fromDate, useCalendar.toDate];
  homepageStore.current = 'none';
};


const isGulet = computed(() => homepageStore.selections.category?.id === 21);
const canSelectSkipper = computed(() => {
  const category = homepageStore.selections.category;
  return category?.id != null && category.id !== 21;
});

const onSelectCategory = (category) => {
  homepageStore.selections.category = category
  if (category) {
    selectedCategoryName.value = category.name
  }
}

function onPassengersAndCabins() {
  homepageStore.selections.passengers = usePassengers.passengers;
  homepageStore.selections.cabins = usePassengers.cabins;
  homepageStore.selections.skipper = usePassengers.skipper;
  homepageStore.current = 'none'
}

function onDayClick(val) {
  console.log("On day click",val)
  const date = new Date(val.date.getTime() - (val.date.getTimezoneOffset() * 60000))
  useCalendar.setDate(date)
  homepageStore.selections.dates = [useCalendar.fromDate, useCalendar.toDate]
}

const onClearFields = () => {
  console.log("Clearing all fields...");

  homepageStore.reset();
  usePassengers.reset();

  // Reset UI bindings
  useDestinationAutocomplete.query = ''; // Clear search query
  useCalendar.clearDates(); // Clear date selections
  homepageStore.selections.dates = [useCalendar.fromDate, useCalendar.toDate]
  range.value = {
    start: null,
    end: null
  };
  useCalendar.text = ''; // Clear date input text
  selectedCategoryName.value = ''; // Clear category input

  console.log("All fields cleared:", homepageStore.selections);
};

const onRecommend =()=>{
  emits('on-recommend')
}

const onSearch =()=>{
  emits('on-search')
}


const onRefresh =()=>{
  emits('on-refresh')
}


const onClose = () => {
  homepageStore.current = 'none'
}

const range = ref({
  start: new Date(2020, 0, 6),
  end: new Date(2020, 0, 10),
});


const onClearDates = () => {
  useCalendar.clearDates();
  homepageStore.selections.dates = [useCalendar.fromDate, useCalendar.toDate]
  range.value = {
    start: null,
    end: null
  };

  console.log("Dates cleared:", range.value);
}

const computedPlaceholder = computed(() => {
  console.log(homepageStore.selections.location.label)
  if (homepageStore.selections.location?.label) {
    return homepageStore.selections.location.label;
  }
  // Otherwise, return the default placeholder text
  return t('booking.selectDestination');
});


const currentFocusIndex = ref(-1);




/****

 TODO 2025-01-16

 This code is trash, we have this here because during development
 Pinia, state management and stores, as well as components, composistion API
 and best practices for component isolation where not used by the inital
 and subsequent developers.

 This needs to be refactored.

 ***/
onMounted(()=>{

  console.log("Mounted",homepageStore.selections)

  if(homepageStore.selections.location && Object.keys(homepageStore.selections.location) > 0){
    console.log("Settign query",homepageStore.selections)
    useDestinationAutocomplete.query = homepageStore.selections.location.label;
  }
  if(homepageStore.selections.dates && homepageStore.selections.dates.length ==2) {
    useCalendar.fromDate = homepageStore.selections.dates[0]
    useCalendar.toDate = homepageStore.selections.dates[1]
  }
  if(homepageStore.selections.passengers) {
    usePassengers.passengers = homepageStore.selections.passengers;
  }
  if(homepageStore.selections.cabins) {
    usePassengers.cabins = homepageStore.selections.cabins;
  }

  if(homepageStore.selections.category){
    selectedCategoryName.value = homepageStore.selections.category.name
  }

  usePassengers.skipper = homepageStore.selections.skipper;

})
function loadPopDestinations() {
  useDestinationAutocomplete.getPopularDestinations()
}
function onApply(location) {
  useDestinationAutocomplete.query = location.name;
  homepageStore.selections.location = location

}



</script>

<template>
  <div class="bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue h-screen">
    <div class="container flex flex-col py-12">
      <button class="self-end" @click="emits('close',true)">
        <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18"/>
      </button>
      <div class="text-black">
        <div class="flex flex-col">
          <div
              class="destination-container-content transition-all text-black/65 flex flex-row items-center gap-2  text-sm">
            <img src="@/assets/icons/svg/Location_16x16.svg" alt="Destination">
            <div class="mobile-labels text-xs">{{ t('search.destinationTitle') }}</div>
          </div>

          <VTextField
              class="field-mobile"
              variant="underlined"
              @click="loadPopDestinations"
              :placeholder="computedPlaceholder"
              :value="homepageStore.selections.location.name || ''"
              :readonly="true"
              v-model="useDestinationAutocomplete.query"
              @click:clear="useDestinationAutocomplete.query=''; homepageStore.selections.location = {}"
              @click.stop="homepageStore.current='destination';"
          >
          </VTextField>

          <CustomModal
              :show="homepageStore.current === 'destination'"
              :drawerHeight="WindowsUtils.modalHeight"
              classes="w-1/6"
              @close="homepageStore.current ='none'"
              :mobile-fullscreen="false">
            <div class="flex flex-col">
              <BookingModalTitle
                  :title="t('search.destinationTitle')"
                  @onClose="onClose"/>

              <div class="flex flex-col gap-6">
                <VTextField
                    variant="underlined"
                    v-model="useDestinationAutocomplete.query"
                    :placeholder="computedPlaceholder"
                    @click:clear="useDestinationAutocomplete.query=''; homepageStore.selections.location = {}"
                >
                </VTextField>
                <div class="destination-picker-results -mt-6 pb-4">
                  <div class="w-full" v-show="useDestinationAutocomplete.loading">
                    <CustomSpinner/>
                  </div>
                  <div v-if="useDestinationAutocomplete.hasResults">
                    <div v-for="rec in useDestinationAutocomplete.locations" :key="rec.id"
                         class="result flex flex-row items-center justify-between mt-4 cursor-pointer"
                         @click="onDestination(rec)">
                      <div>
                        {{ rec.name }}
                      </div>
                      <DestinationPill :destination="rec"/>
                    </div>
                  </div>
                  <div  v-if="useDestinationAutocomplete.hasPopular">
                    <div class="result transition-all flex flex-row items-center justify-between  py-2">
                      <div>
                        <span class="font-bold">Popular Destinations</span>
                      </div>
                    </div>
                  </div>
                  <div class="overflow-y-scroll max-h-50">
                    <div class="destination-picker-results" v-if="useDestinationAutocomplete.hasPopular">
                      <div v-for="(rec,index) in useDestinationAutocomplete.popular"
                           :key="rec.id"
                           :class="`result transition-all flex flex-row items-center justify-between py-2 cursor-pointer
                          ${currentFocusIndex === index ? 'selected-result' : ''}`"
                           @click="onDestination(rec)">
                        <div class="line-clamp-1 text-ellipsis">
                          <span class="">{{ rec.name }}</span>
                        </div>
                        <DestinationPill :destination="rec"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CustomModal>

        </div>
<!--        Calendar-->
        <div class="flex flex-col pt-6">
          <div
              class="destination-container-content transition-all text-black/65 flex flex-row items-center gap-2  text-sm">
            <img src="@/assets/icons/svg/Calendar_16x16.svg" alt="Dates"/>
            <div class="mobile-labels text-xs">{{ t('datePicker.when') }}</div>
          </div>
          <VTextField
              class="field-mobile"
              @click.stop="homepageStore.current = 'date'"
              :persistent-placeholder="true"
              :placeholder="t('boat.selectDate')"
              v-model="useCalendar.text"
              variant="underlined"
              :readonly="true"
              @click:clear="onClearDates"
          >
          </VTextField>

          <CustomModal :show="homepageStore.current == 'date'"
                       :drawerHeight="WindowsUtils.modalHeight"
                       classes="w-1/6"
                       @close="homepageStore.current ='none'"
                       :mobile-fullscreen="false">
            <BookingModalTitle
                :title="t('datePicker.when')"
                @onClose="onClose"/>


            <div class="w-full mt-3 justify-center flex align-center">
              <SwitchToggle :options="[t('datePicker.dates'), t('datePicker.flexible')]"
                            :value="useCalendar.selectedOption"
                            @update:value="val => useCalendar.selectedOption = val as 'Dates' | 'Flexible'"/>
            </div>
            <div v-if="useCalendar.selectedOption === 'Dates'" @click.stop.prevent>
              <VDatePicker
                  expanded
                  v-model.range="range"
                  borderless
                  :rows="1"
                  class="margin-bottom:10px;"
                  :min-date="new Date()"
                  @dayclick="onDayClick"
                  :firstDayOfWeek=2
                  :attributes="useCalendar.dateRange"
              />

            </div>
            <div v-else class="w-full h-full">
              <div class="flex flex-col responsive-title-6 font-semibold mt-7.5">
                <div>{{ t('datePicker.duration') }}</div>
                <div class="flex items-center gap-1.5 mt-2 cursor-pointer w-full justify-center">
                  <VChip :variant="useCalendar.selectedFlexiblePeriod === '7 days' ? 'flat' : 'outlined'"
                         @click="useCalendar.selectedFlexiblePeriod = '7 days'; useCalendar.howManyWeeks = 1">{{ t('datePicker.7days') }}
                  </VChip>
                  <VChip :variant="useCalendar.selectedFlexiblePeriod === '2 weeks' ? 'flat' : 'outlined'"
                         @click="useCalendar.selectedFlexiblePeriod = '2 weeks'; useCalendar.howManyWeeks = 2">{{ t('datePicker.2weeks') }}
                  </VChip>
                  <VChip :variant="useCalendar.selectedFlexiblePeriod === '3 weeks' ? 'flat' : 'outlined'"
                         @click="useCalendar.selectedFlexiblePeriod = '3 weeks'; useCalendar.howManyWeeks = 3">{{ t('datePicker.3weeks') }}
                  </VChip>
                  <VChip :variant="useCalendar.selectedFlexiblePeriod === '1 month' ? 'flat' : 'outlined'"
                         @click="useCalendar.selectedFlexiblePeriod = '1 month'; useCalendar.howManyWeeks = 4">{{ t('datePicker.1month') }}
                  </VChip>
                </div>
              </div>
              <div class="w-full h-full mt-7.5">
                <div class="responsive-title-6 font-semibold mb-3">
                  {{ t('datePicker.months') }}
                </div>
                <VSheet class="flex overflow-x-scroll">
                  <VSlideGroup>
                    <VSlideGroupItem v-for="month in useCalendar.sortedMonths" :key="month.id">
                      <div @click="useCalendar.setMonth(month);"
                           :class="`flex justify-center transition-all month items-center
                          w-20 h-16
                          bg-background-light
                          mx-1 rounded-2xl cursor-pointer
                          ${useCalendar.selectedFlexibleMonth?.id == month.id ? 'border-[1px] border-primary-blue' : ''}`">
                        {{ month.name }}
                      </div>
                    </VSlideGroupItem>
                  </VSlideGroup>
                </VSheet>
              </div>
            </div>
            <div
                class="header-booking-buttons bg-white hidden fixed py-8 px-0 bottom-0 w-screen z-10 left-0 border-t bg-gradient-to-br from-gradients-ghostWhite to-gradients-aliceBlue">
              <div class="container flex justify-between align-center">
                <CustomButton class="hover:bg-black hover:text-white hover:border-black"
                              @click="onClearDates"
                              :disabled="!useCalendar.dateRange[0].dates.length"
                              :outlined="false"
                              type="black"
                              :rounded="true">
                  {{ t('datePicker.clearDates') }}
                </CustomButton>
                <div>
                  <CustomButton type="black"
                                :rounded="true"
                                :outlined="false"
                                class="hover:bg-black hover:text-white hover:border-black"
                                @click="onDate">
                    {{ t('common.apply')}}
                  </CustomButton>
                </div>
              </div>
            </div>
          </CustomModal>
        </div>

<!--        Boat Type-->
        <div class="flex flex-col pt-6">
          <div
              class="destination-container-content transition-all text-black/65 flex flex-row items-center gap-2  text-sm">
            <img src="@/assets/icons/svg/Boat_16x16.svg" alt="Destination">
            <div class="mobile-labels text-xs">{{ t('boat.typeAndLayout') }}</div>
          </div>
          <VTextField class="field-mobile"
                      variant="underlined"
                      :persistent-placeholder="true"
                      :placeholder="t('boat.selectOption')"
                      v-model="selectedCategoryName"
                      :readonly="true"
                      @click.stop="homepageStore.current='boat'"
                      @click:clear="homepageStore.selections.category={}; selectedCategoryName =''"
          />
          <CustomModal :show="homepageStore.current=='boat'"
                       :drawerHeight="WindowsUtils.modalHeight"
                       classes="w-1/6"
                       @close="homepageStore.current = 'none'"
                       :mobile-fullscreen="false">

            <div class="w-full flex flex-col gap-2 max-h-full pt-3 overflow-y-scroll">
              <BookingModalTitle
                  :title="t('boat.selectType')"
                  @onClose="onClose"/>

              <div v-for="category in homepageStore.categories" :key="category.id"
                   :class="`bg-background-light
                            font-semibold
                            responsive-body-small px-4 py-3.5 type select-none cursor-pointer rounded-8xl border-2 transition-all
                            ${homepageStore.selections.category?.id === category.id ? ' border-primary-blue' : 'border-transparent'}`">
                <div class="flex align-center gap-3"
                     @click="onSelectCategory(category)"
                >
                  <img class="boat-icon w-8" :src="AssetsUtils.getCategoryImage(category.id)" :alt="category.name">
                  <div>{{ category.name }}</div>
                </div>
              </div>
            </div>
            <div
              class="header-booking-buttons bg-white hidden fixed py-8 px-0 bottom-0 min-h-10 w-screen z-10 left-0 border-t bg-gradient-to-br from-gradients-ghostWhite to-gradients-aliceBlue">
            <div class="container flex justify-between align-center">
              <div class="flex flex-col">
                <CustomButton
                              @click="() => { homepageStore.selections.category = {}; currentFocusIndex = -1; }"
                              :outlined="true"
                              :rounded="true">
                  {{ t('common.clear') }}
                </CustomButton>
              </div>
              <div>
                <CustomButton type="black"
                              :rounded="true"
                              :outlined="false"
                              @click="onClose">
                  {{ t('common.apply')}}
                </CustomButton>
              </div>
            </div>
          </div>
          </CustomModal>
        </div>
        <div class="flex flex-col pt-6">
          <div
              class="destination-container-content transition-all text-black/65 flex flex-row items-center gap-2  text-sm">
            <img src="@/assets/icons/svg/Guest_16x16.svg" alt="Destination">
            <div class="mobile-labels text-xs">{{ t('booking.passengersAndCabinsTitle') }}</div>
          </div>
          <VTextField
              class="field-mobile"
              :placeholder="usePassengers.text"
              :persistent-placeholder="true"
              variant="underlined"
              :readonly="true"
              @click.stop="homepageStore.current = 'passenger'"
              @click:clear="usePassengers.reset"
          >
          </VTextField>
        </div>
        <CustomModal :show="homepageStore.current == 'passenger'"
                     :drawerHeight="WindowsUtils.modalHeight"
                     classes="w-1/6"
                     @close="homepageStore.current ='none'"
                     :mobile-fullscreen="false">

          <div class="flex flex-col gap-y-4">
            <BookingModalTitle
                :title="t('booking.passengersAndCabinsTitle')"
                @onClose="onClose"/>

            <div class="flex items-center justify-between w-full mt-4">
              <div class="responsive-body-medium font-semibold">{{ t('booking.passengersLabel') }}</div>
              <CustomIncrement :value="usePassengers.passengers"
                               @increment="usePassengers.incrementPassenger"
                               @decrement="usePassengers.decrementPassenger"/>
            </div>
            <div class="flex items-center justify-between w-full">
              <div class=" responsive-body-medium font-semibold">{{ t('booking.cabinsLabel') }}</div>
              <CustomIncrement :value="usePassengers.cabins"
                               @increment="usePassengers.incrementCabin"
                               @decrement="usePassengers.decrementCabin"/>
            </div>
            <div v-if="canSelectSkipper" class="w-full flex flex-row justify-between items-center">
              <div class="flex flex-col items-start justify-between w-8/12 gap-y-1">
                <div class="responsive-body-medium font-semibold">{{ t('booking.skipperLabel') }}</div>
                <div class="responsive-body-small text-black/40">{{ t('booking.skipperInfo') }}</div>
              </div>
              <VSwitch inset v-model="usePassengers.skipper" base-color="grey" color="black" />
            </div>
            <div v-if="isGulet" class="w-full flex flex-row justify-between items-end">
              <div class="responsive-body-small text-black/40">{{ t('booking.noSkipperInfo') }}</div>
            </div>
          </div>

          <div
              class="header-booking-buttons bg-white hidden fixed py-8 px-0 bottom-0 w-screen z-10 left-0 border-t bg-gradient-to-br from-gradients-ghostWhite to-gradients-aliceBlue">
            <div class="container flex justify-between align-center">
              <div class="flex flex-col w-2/4">
              </div>
              <div>
                <CustomButton type="black"
                              :outlined="false"
                              :rounded="true"
                              @click="onPassengersAndCabins">
                  {{ t('common.apply')}}
                </CustomButton>
              </div>
            </div>
          </div>
        </CustomModal>


      </div>
    </div>
  </div>

  <div
      class="header-booking-buttons bg-white hidden fixed py-8 px-0 bottom-0 w-screen z-10 border-t">
    <div class="container flex justify-between align-start h-10">
      <div
          :class="['grid gap-x-5 w-full h-10',
              props.refresh ? 'grid-cols-2 justify-end flex' :
              homepageStore.canRecommend ? 'grid-cols-3' : 'grid-cols-2 justify-end flex',
              homepageStore.canSearch ? 'justify-end flex' : '']">
        <div class="flex flex-col w-full align-start justify-center">
          <div class="price responsive-body-medium">
            <span class="font-semibold responsive-link-small underline cursor-pointer"
                  @click="onClearFields">
              {{ t('clearAll') }}
            </span>
          </div>
        </div>
        <div class="flex flex-col w-full align-center justify-center"
             v-if="homepageStore.canRecommend && homepageStore.canSearch && !props.refresh">
          <CustomButton
              @click="onRecommend"
              :outlined="false"
              :rounded="true"
              type="black"
              class="hover:bg-black hover:text-white hover:border-black mr-auto 1">
            {{ t('search.offersButtonText') }}
          </CustomButton>
        </div>
        <div class="flex flex-col w-full align-center justify-center"
             v-if="homepageStore.canSearch && !props.refresh">
          <CustomButton
              @click="onSearch"
              :outlined="false"
              :rounded="true"
              type="black"
             >
            {{ t('search.buttonText') }}
          </CustomButton>
        </div>
        <span
            v-if="!homepageStore.canSearch && !homepageStore.canRecommend">
          {{ t('search.selectDestination') }}
        </span>
        <CustomButton
            v-if="homepageStore.canRecommend && props.refresh"
            @click="onRefresh"
            :outlined="false"
            :rounded="true"
            type="black"
            class="hover:bg-black hover:text-white hover:border-black mr-auto 1">
          {{ t('search.refresh') }}
        </CustomButton>

      </div>
    </div>
  </div>
</template>


<style scoped>
:deep(.datepicker-calendar) {
  width: 100% !important;
}

:deep(.field-mobile input) {

  font-size: 1.375rem;
}

:deep(.field-mobile input::placeholder) {
  opacity: 1;
  font-size: 1.375rem;
}

:deep(.vc-pane-container){
  margin-top: 30px;
}
:deep(.vc-week){
  margin-bottom: 15px;
}
:deep(.vc-header){
  margin-bottom: 20px;
}


@media (max-width: 786px) {
  .header-booking-buttons {
    display: flex;
  }
}

@media (max-width: 450px) {
  .header-booking-buttons .req__btn {
    font-size: .75rem;
  }

  .header-booking-buttons .date-passengers__text {
    font-size: .75rem;
  }

  .header-booking-buttons .price {
    font-size: .875rem;
  }
}
:deep(.weekday-7 div) {
  @apply font-bold
}

:deep(div .vc-weekday .vc-weekday-7) {
  @apply font-bold
}
:deep(.v-switch__track) {
  opacity: 1;
}

:deep(.btn-black:hover){
  background: black;
  color: white;
}
</style>
